var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _rect9, _rect10, _rect11, _circle, _circle2, _polygon, _polygon2, _path6, _path7, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _ellipse, _path8, _path9, _path10, _path11, _path12, _circle3, _path13, _path14, _path15, _path16, _ellipse2, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawCreativeExperiment8Dk3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 974,
    height: 757.15033,
    viewBox: "0 0 974 757.15033",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "creative experiment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 27,
    width: 248,
    height: 272,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 1,
    width: 248,
    height: 272,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 242.31429,
    width: 13.37143,
    height: 13.37143,
    fill: "#117aca"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 321.31429,
    y: 242.31429,
    width: 13.37143,
    height: 13.37143,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 340.62857,
    y: 242.31429,
    width: 13.37143,
    height: 13.37143,
    fill: "#575a89"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 248.12162,
    width: 52,
    height: 2.10811,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 254.44595,
    width: 52,
    height: 2.10811,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 260.77027,
    width: 52,
    height: 2.10811,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M526,119.92483v22A66,66,0,0,1,572.66907,254.5939l15.55633,15.55634A88,88,0,0,0,526,119.92483Z",
    transform: "translate(-113 -70.92483)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M588.2254,270.15024,572.66907,254.5939a65.98346,65.98346,0,0,1-86.6,5.87164L472.7533,277.9863a87.99778,87.99778,0,0,0,115.4721-7.83606Z",
    transform: "translate(-113 -70.92483)",
    fill: "#575a89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M460,207.92483a66,66,0,0,1,66-66v-22A87.99914,87.99914,0,0,0,472.7533,277.9863l13.31579-17.52076A65.88493,65.88493,0,0,1,460,207.92483Z",
    transform: "translate(-113 -70.92483)",
    fill: "#117aca"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M691.122,647.82517A50.122,50.122,0,0,1,641,597.70312V539.325c0-116.80811,94.69168-211.49979,211.49979-211.49979h.00042C969.30832,327.82517,1064,422.51685,1064,539.325v45.89391a62.6063,62.6063,0,0,1-62.6063,62.6063",
    transform: "translate(-113 -70.92483)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.39355,710.82517v-2A61.67646,61.67646,0,0,0,1084,647.21872V527.32517c0-116.07032-94.42969-210.5-210.5-210.5S663,411.25485,663,527.32517V659.7031a49.17779,49.17779,0,0,0,49.12207,49.12207v2A51.18008,51.18008,0,0,1,661,659.7031V527.32517c0-117.17285,95.32715-212.5,212.5-212.5s212.5,95.32715,212.5,212.5V647.21872A63.67906,63.67906,0,0,1,1022.39355,710.82517Z",
    transform: "translate(-113 -70.92483)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 547,
    y: 562.90033,
    width: 427,
    height: 176,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 907.86031,
    y: 462.78515,
    width: 50,
    height: 50,
    transform: "matrix(0.81503, -0.57942, 0.57942, 0.81503, -223.08114, 559.81431)",
    fill: "#117aca"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 911.13969,
    y: 451.86518,
    width: 50,
    height: 50,
    transform: "matrix(0.81503, -0.57942, 0.57942, 0.81503, -216.14735, 559.69458)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 341.90033,
    r: 21,
    fill: "#117aca"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 744,
    cy: 338.90033,
    r: 21,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "687.934 425.82 713.068 440.287 738.201 454.754 713.105 469.287 688.01 483.82 687.972 454.82 687.934 425.82",
    fill: "#117aca"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.895 436.803 709.028 451.271 734.162 465.738 709.066 480.271 683.97 494.803 683.932 465.803 683.895 436.803",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M698.43492,449.64862a87.83931,87.83931,0,0,1,55.55779-59.22684c3.6301-1.248,2.0705-7.04588-1.595-5.78567a94.08133,94.08133,0,0,0-59.74843,63.41747c-1.02951,3.7274,4.75739,5.318,5.78568,1.595Z",
    transform: "translate(-113 -70.92483)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M687.05512,482.41572c3.86071,0,3.86711-6,0-6-3.86072,0-3.86711,6,0,6Z",
    transform: "translate(-113 -70.92483)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 402.82517,
    width: 98,
    height: 120,
    transform: "translate(44.45 -162.06206) rotate(17.60473)",
    fill: "#f2f2f2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 356.91571,
    y: 422.852,
    width: 38.47953,
    height: 2.12865,
    transform: "translate(32.82986 -164.83869) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 355.31686,
    y: 429.2473,
    width: 56,
    height: 2.12865,
    transform: "translate(35.09951 -166.70512) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 352.85476,
    y: 435.65007,
    width: 38.47953,
    height: 2.12865,
    transform: "translate(36.51042 -163.01108) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 348.10048,
    y: 450.63316,
    width: 38.47953,
    height: 2.12865,
    transform: "translate(40.81938 -160.87143) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 351.25591,
    y: 442.04536,
    width: 56,
    height: 2.12865,
    transform: "translate(38.78007 -164.87751) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 350.06734,
    y: 445.79113,
    width: 56,
    height: 2.12865,
    transform: "translate(39.85731 -164.3426) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 348.87877,
    y: 449.53691,
    width: 56,
    height: 2.12865,
    transform: "translate(40.93455 -163.80769) rotate(17.60473)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 345.13755,
    y: 456.8316,
    width: 20.14035,
    height: 5.56725,
    transform: "translate(42.64587 -156.83115) rotate(17.60473)",
    fill: "#117aca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131,
    cy: 740.15033,
    rx: 131,
    ry: 17,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.12316,340.451l-4.35152,10.33486,4.89546,66.90465s-2.7197,3.80759,0,6.52729,2.17576,3.80758,2.17576,3.80758-4.35152,0-2.17576,3.26364,2.17576,4.89546,2.17576,4.89546l-1.08788,3.26364s2.17576,2.7197,2.17576,4.89547S200.07319,513.424,200.07319,513.424l13.5985-26.65308-7.61516-106.06834Z",
    transform: "translate(-113 -70.92483)",
    fill: "#117aca"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.758,510.587s29.699-1.19961,39.168,9.27684-37.2018,2.89739-39.8415-.05442S321.758,510.587,321.758,510.587Z",
    transform: "translate(-113 -70.92483)",
    fill: "#ffb9b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.05194,774.51532l-5.98335,19.58185s-8.703,19.03791,3.26364,21.75761,23.38944-7.61516,23.38944-7.61516V795.18505l4.35152-20.66973Z",
    transform: "translate(-113 -70.92483)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.96118,774.51532s-2.7197,36.98794,3.26364,39.1637,27.197,2.7197,27.741,0,7.07123-5.4394,2.17576-9.247-8.1591-26.10914-8.1591-26.10914Z",
    transform: "translate(-113 -70.92483)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.02322,424.21781V440.536s-17.95,37.53188-24.47732,96.82137S164.71707,777.235,170.15647,780.49867s64.18495,5.4394,65.81677,1.08788S239.23688,649.953,239.23688,649.953l20.12579-89.75014s3.80759,32.09247,7.07123,37.53187-5.43941,182.22,0,184.93969,78.87133,7.61516,77.78345-1.08788-25.56519-244.77311-25.56519-244.77311S306.14153,425.30569,302.334,424.21781s-38.61975-2.17576-44.05916-1.08788S218.02322,424.21781,218.02322,424.21781Z",
    transform: "translate(-113 -70.92483)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.36267,
    cy: 187.3912,
    r: 31.00459,
    fill: "#ffb9b9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.89,284.42516s-15.77427,24.47732-11.96669,31.0046-40.25158-6.52728-40.25158-6.52728,26.65308-32.63642,26.10913-36.444S265.89,284.42516,265.89,284.42516Z",
    transform: "translate(-113 -70.92483)",
    fill: "#ffb9b9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M298.52637,320.86916s-28.82883-9.247-32.63641-13.05457a52.31836,52.31836,0,0,1-6.52729-8.1591s-34.81217-4.89546-35.9-4.89546-9.247,9.79092-11.42275,11.96668-29.91671,16.86215-29.91671,20.66973-4.35152,23.38943-4.35152,23.38943,9.79092,20.12579,15.77426,24.47731,7.61517,3.26365,8.15911,10.33487,8.1591,18.494,8.1591,18.494,4.89546,12.51062,3.80758,16.31821-5.98334,7.07122,5.43941,5.98334,67.99253,2.17576,67.99253-3.80758-10.87881-63.09707-10.87881-63.09707Z",
    transform: "translate(-113 -70.92483)",
    fill: "#117aca"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M288.19151,321.957l10.33486-1.08788s3.80758,2.17576,4.35152,23.38943.54394,72.344,4.35153,76.69558,19.58184,71.80011,19.58184,71.80011,4.35153,1.08788,4.35153,4.89546,4.89546,7.07122,2.7197,11.42274,2.17576,3.26365-.54394,5.98335-15.77427,8.1591-16.31821,4.89546,1.63182-3.80758-.54394-4.89546-2.17576-1.63182-2.7197-5.43941-5.4394-7.61516-4.89546-9.247-23.93337-48.95462-23.93337-50.58644-1.63183-7.61517-3.80759-8.70305-5.4394-2.17576-3.80758-4.89546-4.35152-84.31074-4.35152-84.31074Z",
    transform: "translate(-113 -70.92483)",
    fill: "#117aca"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M285.58136,238.65336c-9.50754-10.32052-24.43845-15.79831-38.13088-12.72851s-25.22222,15.22639-26.29294,29.21781c-.219,2.862-.03658,5.78533-.77714,8.55856-1.24558,4.66446-4.952,8.36136-6.25866,13.00907-.87517,3.11284-.61579,6.46455-1.54332,9.5622-1.71391,5.72391-7.0189,9.456-11.0622,13.85511a14.02046,14.02046,0,0,0-3.54109,5.79486,21.85181,21.85181,0,0,0-.26791,5.89668,41.0573,41.0573,0,0,1-11.00759,28.642,70.65247,70.65247,0,0,1,13.69788-7.9634c-2.404,7.65546-.20626,16.71331,5.84256,21.98559s15.737,6.09142,22.2772,1.44265c3.88527-2.76166,6.40882-7.00037,8.8191-11.11288l9.12588-15.57094c1.65067-2.81643,3.374-5.71481,6.01148-7.63856,2.096-1.52878,4.64268-2.34222,6.75251-3.85181,5.32221-3.80807,6.75125-11.26127,5.76025-17.73005s-3.90007-12.47487-5.56847-18.80288c-1.31957-5.00494-1.73366-10.74071,1.23492-14.9808,3.94051-5.6283,12.03886-6.3464,17.39337-10.65157,2.01594-1.62087,2.91656-3.593,4.36041-5.62191,1.33293-1.87308,1.6725-1.20168,3.73788-1.28729C291.81566,248.44227,287.68282,240.93452,285.58136,238.65336Z",
    transform: "translate(-113 -70.92483)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.5,
    cy: 198.15033,
    rx: 2.5,
    ry: 6,
    fill: "#ffb9b9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 421,
    cy: 598.90033,
    r: 32,
    fill: "#f2f2f2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 48.90033,
    r: 32,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 771,
    cy: 123.90033,
    r: 32,
    fill: "#f2f2f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCreativeExperiment8Dk3);
export default __webpack_public_path__ + "static/media/undraw_creative_experiment_-8-dk3.5a4189c119f4fbc4ac3a4babc21ac1d3.svg";
export { ForwardRef as ReactComponent };